"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENV_NAMES = {
    MCS_RUN_ENV: 'MCS_RUN_ENV',
};
//# sourceMappingURL=constants.js.map